<template>  
    <div>

        <b-row>
            <b-col cols="12" class="mb-13">

                <b-button block 
                          id="admin-btn-save" 
                          class="admin-button" 
                          @click="hideResultAudit">
                    Скрыть
                </b-button>

            </b-col>
        </b-row>     

        <b-list-group>
            <b-list-group-item>
                <b-row>
                    <b-col cols="7" class="wrap-name-property"> 
                        <h4 class="mb-20">Информация об аудите </h4> 
                        <div class="mb-5px"> <span>Id результата аудита: </span> {{ vm.Guid }} </div>
                        <div class="mb-5px"> <span>Имя: </span> 
                          {{ getDateToDisplay(vm.Name, localTimeZone, true) }} 
                          {{ localTimeZone!= '00:00:00' ?  `(GMT+${Number(localTimeZone.split(':')[0])})` : ''}} 
                        </div>
                        <div class="mb-5px"> <span>Дата создания аудита: </span> 
                          {{ getDateToDisplay(vm.DateCreated, localTimeZone) }}
                          {{ localTimeZone != '00:00:00' ? `(GMT+${Number(localTimeZone.split(':')[0])})` : '' }} 
                        </div>
                        <div class="mb-5px"> <span>Дата загрузки: </span> 
                          {{ getDateToDisplay(vm.DateFinished, localTimeZone, false, true)}}
                          {{ localTimeZone != '00:00:00' ? `(GMT+${Number(localTimeZone.split(':')[0])})` : '' }}  
                        </div>
                        <div class="mb-5px"> <span>Местоположение создания аудита: </span> {{ locationText(vm.CreationLocation) }} </div>
                        <div class="mb-5px"> <span>Местоположение завершения аудита: </span> {{ locationText(vm.CompletionLocation) }} </div>
                        <div class="mb-5px"> <span>Комментарий: </span> {{ vm.Comment }} </div>
                        <div class="mb-5px"> <span>Тип: </span> {{  type }} </div>
                        <div class="mb-5px"> <span>Id акстивности: </span> {{ vm.Activities[0].Id }} </div>
                        <div class="mb-5px"> <span>Название акстивности: </span> {{ vm.Activities[0].Name }} </div>
                        <div class="mb-5px"> <span>Ошибки в аудите: </span> {{ userErrors }} </div>
                    </b-col>
                    <b-col cols="5" class="wrap-name-property">
                        <h4 class="mb-20">Информация о пользователе</h4> 
                        <div class="mb-5px"> <span>Id пользователя: </span> {{ vm.Creator.Id }}  </div>
                        <div class="mb-5px"> <span>Полное имя: </span> {{ vm.Creator.FullName }} </div>
                        <div class="mb-5px"> <span>DAX: </span> {{ vm.Creator.DAX }} </div>
                        <div class="mb-5px"> <span>Права: </span> {{  creatorRights }}  </div>
                        <div class="mb-5px"> <span>Статус: </span> {{  creatorStatus }}  </div>
                    </b-col>
                </b-row>
            </b-list-group-item>
        </b-list-group>
        <b-row>

            <b-col cols="5">
                <b-list-group style="margin-top: 15px;">
                    <b-list-group-item v-for="(form, index) in vm.Forms" :key="index" class="wrap-name-property">

                        <div v-if="form.TradePoint != null" class="mb-5px fs-17"> 
                            <a href="#"
                               class="admin-link"  
                               @click="vm.ShowTradePoint(index)">
                            {{ form.TradePoint.MDRetailChainName }}
                            </a>
                        </div>

                        <div v-if="form.Questions.length" class="mb-5px fs-17"> 
                            <a href="#" class="admin-link" @click="vm.ShowQuestions(index)">Вопросы</a> 
                        </div>

                        <div v-if="form.Photos.length" class="mb-5px fs-17"> 
                            <a href="#" class="admin-link" @click="vm.ShowPhotos(index)"> Фото</a> 
                        </div>

                        <div class="mb-5px"> <span> Время создания анкеты: </span> 
                          {{ getDateToDisplay(form.CreationDate, localTimeZone) }}
                          {{ localTimeZone != '00:00:00' ? `(GMT+${Number(localTimeZone.split(':')[0])})` : '' }}  
                        </div>
                        <div class="mb-5px"> <span> Время завершения анкеты: </span> 
                          {{ getDateToDisplay(form.CompletionDate, localTimeZone) }}
                          {{ localTimeZone != '00:00:00' ? `(GMT+${Number(localTimeZone.split(':')[0])})` : '' }} 
                        </div>
                        <div class="mb-5px"> <span> Местоположение создания анкеты: </span> {{locationText(form.CreationLocation) }} </div>
                        <div class="mb-5px"> <span> Местоположение завершения анкеты: </span> {{locationText(form.CompletionLocation) }} </div>
                        <div class="form-number"> {{ index + 1}}</div>
                    </b-list-group-item>
                </b-list-group>
            </b-col>

            <a href="" name="top"></a>

            <b-col cols="7" v-if="vm.IsTTVisible">
                <b-list-group style="margin-top: 15px;">
                    <h4> {{  headerForm }}</h4>
                    <h5> {{  headerTT }}</h5>
                    <b-list-group-item class="wrap-name-property">                        
                        <div class="mb-5px"> <span>Id торговой точки: </span> {{vm.SelectedForm.TradePoint.Id }} </div>                    
                        <div class="mb-5px"> <span>DATELASTINVOICE: </span> {{vm.SelectedForm.TradePoint.DATELASTINVOICE }} </div>
                        <div class="mb-5px"> <span>ACCOUNTNUM: </span> {{vm.SelectedForm.TradePoint.ACCOUNTNUM }} </div>
                        <div class="mb-5px"> <span>ACCOUNTNAME: </span> {{ vm.SelectedForm.TradePoint.ACCOUNTNAME }} </div>
                        <div class="mb-5px"> <span>ParentSALESPLACEID: </span> {{ vm.SelectedForm.TradePoint.ParentSALESPLACEID }} </div>
                        <div class="mb-5px"> <span>Филиал: </span> {{ vm.SelectedForm.TradePoint.Branch }} </div>
                        <div class="mb-5px"> <span>Код региона: </span> {{ vm.SelectedForm.TradePoint.Region }} </div>
                        <div class="mb-5px"> <span>Дата последнего изменения: </span> {{ vm.SelectedForm.TradePoint.DateModified }} </div>
                        <div class="mb-5px"> <span>Широта: </span> {{ vm.SelectedForm.TradePoint.Latitude }} </div>
                        <div class="mb-5px"> <span>Долгота: </span> {{ vm.SelectedForm.TradePoint.Longitude }} </div>
                        <div class="mb-5px"> <span>MDRetailChainId: </span> {{ vm.SelectedForm.TradePoint.MDRetailChainId }} </div>
                        <div class="mb-5px"> <span>MDRetailChainName: </span> {{ vm.SelectedForm.TradePoint.MDRetailChainName }} </div>
                        <div class="mb-5px"> <span>Адрес: </span> {{ vm.SelectedForm.TradePoint.Address }} </div>
                        <div class="mb-5px"> <span>Подтип торговой точки: </span> {{ vm.SelectedForm.TradePoint.SubType }} </div>
                        <div class="mb-5px"> <span>Тип торговой точки: </span> {{ vm.SelectedForm.TradePoint.Type }} </div>
                        <div class="mb-5px"> <span>S1: </span> {{ vm.SelectedForm.TradePoint.S1 }} </div>
                        <div class="mb-5px"> <span>AmountRub1m: </span> {{ vm.SelectedForm.TradePoint.AmountRub1m }} </div>
                        <div class="mb-5px"> <span>AvgOrderRub: </span> {{ vm.SelectedForm.TradePoint.AvgOrderRub }} </div>
                        <div class="mb-5px"> <span>AvgFbinCnt: </span> {{ vm.SelectedForm.TradePoint.AvgFbinCnt }} </div>
                        <div class="mb-5px"> <span>AvgMMLFbinCnt: </span> {{ vm.SelectedForm.TradePoint.AvgMMLFbinCnt }} </div>
                        <div class="mb-5px"> <span>FIOTP: </span> {{ vm.SelectedForm.TradePoint.FIOTP }} </div>
                        <div class="mb-5px"> <span>PhoneTP: </span> {{ vm.SelectedForm.TradePoint.PhoneTP }} </div>
                        <div class="mb-5px"> <span>FIOMerch: </span> {{ vm.SelectedForm.TradePoint.FIOMerch }} </div>
                        <div class="mb-5px"> <span>DAXMerch: </span> {{ vm.SelectedForm.TradePoint.MerchResponsibleId }} </div>
                        <div class="mb-5px"> <span>PhoneMerch: </span> {{ vm.SelectedForm.TradePoint.PhoneMerch }} </div>
                        <div class="mb-5px"> <span>FIOSV: </span> {{ vm.SelectedForm.TradePoint.FIOSV }} </div>
                        <div class="mb-5px"> <span>PhoneSV: </span> {{ vm.SelectedForm.TradePoint.PhoneSV }} </div>
                        <div class="mb-5px"> <span>FIOKAM: </span> {{ vm.SelectedForm.TradePoint.FIOKAM }} </div>
                        <div class="mb-5px"> <span>PhoneKAM: </span> {{ vm.SelectedForm.TradePoint.PhoneKAM }} </div>
                        <div class="mb-5px"> <span>Сегмент: </span> {{ vm.SelectedForm.TradePoint.Segment }} </div>
                        <div class="mb-5px"> <span>Формат магазина: </span> {{ vm.SelectedForm.TradePoint.FormatId }} </div>
                        <div class="mb-5px"> <span>Код розничной сети: </span> {{ vm.SelectedForm.TradePoint.MDChainId }} </div>
                        <div class="mb-5px"> <span>Код РМП у Дистрибьютора: </span> {{ vm.SelectedForm.TradePoint.SalesPlaceBuyerCode }} </div>
                        <div class="mb-5px"> <span>DaxId ответственного за ТТ сотрудника: </span> {{ vm.SelectedForm.TradePoint.ChiefResponsibleId }} </div>
                    </b-list-group-item>
                </b-list-group>
            </b-col >

            <b-col cols = "7" v-if="vm.IsQuestionsVisible" style="margin-top: 15px;">
                <h4> {{  headerForm }}</h4>
                <h5> {{  headerTT }}</h5>

                <b-list-group v-for="question in vm.SelectedForm.Questions" 
                              :key="question.Id" 
                              style="margin-bottom: 5px;">                    
                    <!-- Вопрос -->
                    <b-list-group-item class="wrap-name-property">
                        <div class="mb-5px"> <span>Id вопроса: </span> {{ question.QuestionId }} </div>
                        <div class="mb-5px"> <span>Название: </span> {{ question.Name }} </div>                        
                        <div class="mb-5px"> <span>Тип ответа на вопрос: </span> {{ getAnswerType(question.AnswerType) }} </div>
                        <div class="mb-5px"> <span>Комментарий к вопросу: </span> {{  question.Comment ? question.Comment : 'Пусто' }} </div>
                        <div class="mb-5px"> <span v-if="question.Answers.length">Ответы на вопрос: </span> </div>                 
                        <!-- Ответы -->
                        <b-list-group v-for="(answer, index) in question.Answers"
                                      :key='index' 
                                      style="padding-left: 20px; margin-bottom: 3px;">
                            <b-list-group-item variant="dark">
                                <div> Ответ: {{ answer.Value }} </div>
                                <div> Вес ответа: {{answer.Weight}} </div>
                                <div> Выделен ли ответ: {{ answer.Checked ? 'Да' : 'Нет' }} </div>  
                                <div v-if="answer.Questions.length">Список подвопросов: </div> 
                            </b-list-group-item>
                            <!-- Подвопросы --> 
                            <div  v-if="answer.Questions.length">                           
                                <b-list-group-item variant="light"                                                     
                                                    v-for="subQuestion in answer.Questions" 
                                                    :key="subQuestion.Id"
                                                    style="padding-left: 40px;">
                                    <div> Id подвопроса: {{ subQuestion.QuestionId }} </div>
                                    <div> Название: {{ subQuestion.Name }} </div>                                
                                    <div> Тип ответа на подвопрос: {{ getAnswerType(subQuestion.AnswerType) }} </div>
                                    <!-- Ответы на подвопрос -->
                                    <div v-for="(subAnswer) in subQuestion.Answers" :key="subAnswer.Id">
                                        <div> Ответ: {{ subAnswer.Value }} </div>  
                                        <div> Вес ответа: {{subAnswer.Weight}} </div>
                                        <div> Выделен ли ответ: {{subAnswer.Checked ? 'Да' : 'Нет' }} </div>
                                    </div>  
                                </b-list-group-item>   
                            </div>           
                        </b-list-group>
                    </b-list-group-item>
                </b-list-group>
            </b-col>

            <b-col cols="7" v-if="vm.IsPhotosVisible">
                <b-list-group style="margin-top: 15px;">
                    <h4> {{  headerForm }}</h4>
                    <h5> {{  headerTT }}</h5>

                    <b-list-group-item v-for="(photo, index) in vm.SelectedForm.Photos" :key="index" class="wrap-name-property">                            
                        <div class="mb-5px"> <span>Имя файла: </span> <a :href="photo.FileName" class="admin-link"> {{ photo.FileName }}</a> </div>
                        <div class="mb-5px"> <span>Комментарий: </span> {{ photo.Comment }} </div>
                        <div class="mb-5px"> <span>Дата и время создания изображения: </span> 
                          {{ getDateToDisplay(photo.CreationDate, localTimeZone) }}
                          {{ localTimeZone != '00:00:00' ? `(GMT+${Number(localTimeZone.split(':')[0])})` : '' }} 
                        </div>
                        <div class="mb-5px"> <span>Код в справочнике категорий фото: </span> {{ photo.CategoryId }} </div>                
                        <div class="mb-5px"> <span>Местоположение создания изображения: </span> {{ locationText(photo.CreationLocation) }} </div>  
                    </b-list-group-item>                  
                </b-list-group>
            </b-col>         
        </b-row> 

    </div>
    
</template>
<script>

import Consts from '@/store/models/consts/adminConsts'
import WrapperResultAuditModel from '@/store/models/admin/audits/WrapperResultAudit'

export default {
    model:{
        event: 'show'
    },
    props:{
        audit: {
            type: Object,
            default: () => {}
        },
        localTimeZone: {
          type: String,
          default: "00:00:00"
      },
      isWeb: {
        type: String,
        default: "Web"
      }
    },
    computed:{
        userErrors: function() {
            let text = "";

            for (var i = 0; i < this.vm.UserErrors.length; i++) {
                switch (this.vm.UserErrors[i]) {

                case 1:
                    text += "Включен FakeGps;";
                        break;

                case 2:
                    text += "Некорректное время;";
                    break;

                case 3:
                    text += "Аудит пройден без интернета";
                    break;

                default:
                    text += "Непонятное значение";
                    break;
                }
            }

            if (text == "") text = "Пусто";
            return text;
        },
        headerForm: function(){
            return `Форма ${this.vm.IndexForm + 1}`;
        },
        headerTT: function() {
            return this.vm.SelectedForm.TradePoint 
                        ? this.vm.SelectedForm.TradePoint.MDRetailChainName
                        : null;
        },
        type: function() {
            return Consts.AuditType.find(e => e.Id == this.vm.Type).Text;
        },
        creatorRights: function() {
            return Consts.UserRights.find(e => e.Id == this.vm.Creator.Rights).Text;
        },
        creatorStatus: function() {
            return Consts.UserStatus.find(e => e.Id == this.vm.Creator.Status).Text;
        }
    },
    data: function(){
        let vm = new WrapperResultAuditModel(this.audit);

        return{           
          vm: vm
        };
    },
    methods:{
        hideResultAudit: function() {
            this.$emit('show', false);
        },
        getAnswerType: function(value) {
            return Consts.AnswerTypesDax.find(e => e.Id == value).Text;
        },
        
        locationText(location) {
            var locAllowed = location.IsLocationAllowed ? "[Ok]" : "[Доступ не дан]";
            if (location.Coordinates === null)
                return locAllowed + " Координат нет";

            return locAllowed + " " + location.Coordinates.Latitude + " | " + location.Coordinates.Longitude;
        },

      getDateToDisplay: function (value, localTimeZone, parseDateToRu, offBrowserLocalTimeZone) {
        let dateToDisplay = new Date(value);
        if (parseDateToRu && this.isWeb != 'Web') {
          dateToDisplay = dateToDisplay.toLocaleString()
        }
        //Проверка корректного преобразования значения в дату
        if (Number.isNaN(Number(dateToDisplay))) {
          return value
        }
        this.localTimeZone = localTimeZone != undefined ? localTimeZone : this.localTimeZone;
        //Получение даты с учетом след. факторов: откуда аудит, проверка переменную "localTimeZone",
        //и обработка с учетом GMT+3 на сервере
        localTimeZone != undefined && this.localTimeZone != '00:00:00' && (this.isWeb == 'Web' ? true : offBrowserLocalTimeZone) ?
          3 > Number(localTimeZone.split(':')[0])
            ? dateToDisplay.setHours(dateToDisplay.getHours() - (3 - Number(localTimeZone.split(':')[0])))
            : dateToDisplay.setHours(dateToDisplay.getHours() + (Number(localTimeZone.split(':')[0]) - 3))
          : dateToDisplay;
          console
        dateToDisplay = `${this.getDateString(dateToDisplay)} ${this.getTimeString(dateToDisplay)}`;
        return dateToDisplay;
      },

        getDateString(value) {
            const date = `${value.getDate()}`.length == 1
                            ? `0${value.getDate()}`
                            : value.getDate();

            const month = `${value.getMonth() + 1}`.length == 1
                            ? `0${value.getMonth() + 1}`
                            : value.getMonth() + 1;

            const year = value.getFullYear();

            return `${date}.${month}.${year}`;
        },

        getTimeString(value) {
            const hours = `${value.getHours()}`.length == 1 
                            ? `0${value.getHours()}`
                            : value.getHours();

            const minutes = `${value.getMinutes()}`.length == 1 
                            ? `0${value.getMinutes()}`
                            : value.getMinutes();

            const seconds = `${value.getSeconds()}`.length == 1 
                            ? `0${value.getSeconds()}`
                            : value.getSeconds();

            return `${hours}:${minutes}:${seconds}`;
        },
    }
}
</script>